/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface JobEntryFiltersDTO
 */
export interface JobEntryFiltersDTO  {
    /**
     * 
     * @type {Array<string>}
     * @memberof JobEntryFiltersDTO
     */
    statusTypes?: Array<string>;
}

/**
 * Check if a given object implements the JobEntryFiltersDTO interface.
 */
export function instanceOfJobEntryFiltersDTO(value: object): value is JobEntryFiltersDTO {
    return true;
}

export function JobEntryFiltersDTOFromJSON(json: any): JobEntryFiltersDTO {
    return JobEntryFiltersDTOFromJSONTyped(json, false);
}

export function JobEntryFiltersDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobEntryFiltersDTO {
    if (json == null) {
        return json;
    }
    return {
        
              'statusTypes': json['statusTypes'] == null ? undefined : json['statusTypes'],
    };
}

export function JobEntryFiltersDTOToJSON(json: any): JobEntryFiltersDTO {
    return JobEntryFiltersDTOToJSONTyped(json, false);
}

export function JobEntryFiltersDTOToJSONTyped(value?: JobEntryFiltersDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'statusTypes': value['statusTypes'] == null? value['statusTypes']: value['statusTypes'],
    };
}


